import { useEffect, useState } from "react";

interface Props {
  htmlElement: HTMLElement;
}

const useResizeObserver = ({ htmlElement }: Props): DOMRectReadOnly => {
  const [elementRect, setElementRect] = useState<DOMRectReadOnly>({} as DOMRectReadOnly);

  let observer: ResizeObserver = null;

  const observeElement = (element: HTMLElement): void => {
    observer = new ResizeObserver(([resizedHeader]): void => {
      if (!resizedHeader) return;
      const { contentRect } = resizedHeader;

      if (contentRect) {
        setElementRect(contentRect);
      }
    });

    observer.observe(element);
  };

  useEffect(() => {
    if (!window.ResizeObserver || !htmlElement) return undefined;

    if (observer) {
      observer.disconnect();
    }

    observeElement(htmlElement);

    return () => {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [htmlElement]);

  return elementRect;
};

export default useResizeObserver;
